var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImpartiality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 49.609,
    viewBox: "0 0 52 49.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "scale-good-justice-fairness-svgrepo-com",
    d: "M40.148,49.17h-.913a9.783,9.783,0,1,0,19.565,0h-.913L51.322,27.387h.2v-2.8H34.5l.043-6.783H31.1l.043,6.783H14.083v2.8h.2L7.735,49.17H6.8a9.783,9.783,0,1,0,19.565,0h-1.13L18.691,27.387l12.391.087V61.452l-.022-.065v.13H16.539v5.891h32.5V61.5H34.517v-.13l-.022.065V27.474l12.391-.087L40.322,49.17Zm-17.065,0h-13l6.391-21.543.065-.022ZM49.039,27.583l.065.022L55.5,49.148h-13Z",
    transform: "translate(-6.8 -17.8)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImpartiality);
export default __webpack_public_path__ + "static/media/icon-impartiality.58461f9d9c6fe6c4a8a1603717a258ca.svg";
export { ForwardRef as ReactComponent };